import { useTranslation } from 'react-i18next'
import { NavLink } from 'react-router-dom'

import { cn } from '@/lib/utils'

const tabs = [
  { to: '/workbench', labelKey: 'navigation.workbench' },
  // { to: '/history', labelKey: 'navigation.history' },
  // { to: '/palettes', labelKey: 'navigation.palettes' },
  // { to: '/compare', labelKey: 'navigation.compare' },
  { to: '/library', labelKey: 'navigation.product_library' },
]

export const DesktopTabs = ({ className }: { className?: string }) => {
  const { t } = useTranslation('common')

  return (
    <nav className={cn('items-center gap-1', className)}>
      {tabs.map((tab) => (
        <NavLink
          key={tab.to}
          to={tab.to}
          className={({ isActive }) =>
            cn(
              'rounded px-3 py-2 text-sm font-medium text-muted-foreground transition-colors hover:bg-primary-soft hover:text-primary',
              isActive && 'bg-primary text-primary-foreground shadow-sm hover:bg-primary hover:text-primary-foreground',
            )
          }
        >
          {t(tab.labelKey)}
        </NavLink>
      ))}
    </nav>
  )
}
